export const microAppDirectAccessWhiteList = ["/bangbotUi"];

export function isMicroAppDirectAccessWhiteList(path = "") {
  return microAppDirectAccessWhiteList.some((whitePath) => {
    return path === whitePath || path.startsWith(whitePath + "/");
  });
}
